<div mat-dialog-title>
  <h1  fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
    <span>Add Release Items</span>
    <button mat-icon-button mat-dialog-close [disabled]="addingReleaseItems" matTooltip="Cancel" aria-label="Cancel">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
</div>
<!-- render type selecting -->
<mat-card *ngIf="selectedProductName === undefined" class="w-100 contrast mat-card-inline-sm banner-incomplete" (click)="selectProductName(productNames.Panorama)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <strong>Please select a render type to continue</strong>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="selectedProductName !== undefined" class="w-100 contrast mat-card-inline-sm banner-info">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <strong [style.color]="getProductColour(selectedProductName)">{{ productNames[selectedProductName] }}</strong>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="selectedProductName === undefined" class="w-100 contrast card-link mat-card-inline-sm" (click)="selectProductName(productNames.Panorama)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <strong [style.color]="getProductColour(productNames.Panorama)">{{ productNames[productNames.Panorama] }}</strong>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="selectedProductName === undefined" class="w-100 contrast card-link mat-card-inline-sm" (click)="selectProductName(productNames.Facade)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <strong [style.color]="getProductColour(productNames.Facade)">{{ productNames[productNames.Facade] }}</strong>
    </div>
  </mat-card-content>
</mat-card>
<!-- home config selections -->
<mat-card class="w-100 contrast mat-card-inline-sm banner-info">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
      <strong class="highlight">{{ this.data.homeConfigIds?.length }} home configs to add</strong>
    </div>
  </mat-card-content>
</mat-card>
<!-- template selecting -->
<mat-card *ngIf="selectedProductName !== undefined && getSelectedItemCount() > 0" class="w-100 contrast mat-card-inline-sm banner-info">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
      <strong class="highlight">x{{ getSelectedItemCount() }} style templates</strong>
      <mat-icon *ngIf="!doneSelectingTemplates" color="accent" matTooltip="Done selecting templates" (click)="doneSelectingTemplates = true;">check</mat-icon>
      <mat-icon *ngIf="doneSelectingTemplates" matTooltip="Select more templates" (click)="doneSelectingTemplates = false;">clear</mat-icon>
    </div>
  </mat-card-content>
</mat-card>
<div *ngIf="selectedProductName !== undefined && !doneSelectingTemplates">
  <mat-card *ngIf="getSelectedItemCount() < 1" class="w-100 contrast mat-card-inline-sm banner-incomplete">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
        <strong>Now select style templates</strong>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="contrast mat-card-inline-sm">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <mat-form-field>
        <input matInput type="text"
          [formControl]="searchTemplatesField"
          (keyup)="doTemplateFilter($event.target.value)"
          (keyup.esc)="$event.target.value=''; doTemplateFilter('')"
          placeholder="Filter style templates by name">
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <ng-container *ngFor="let item of filteredStyleConfigTemplates">
    <mat-card class="contrast card-link mat-card-inline-sm" (click)="selectTemplate(item)" [class.banner-info]="item.selected">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
          <strong matTooltip="Style Template" [innerHtml]="item.item | encodeHtml | highlight: searchTemplatesField.value"></strong>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
<!-- release selecting -->
<mat-card *ngIf="selectedProductName !== undefined  && doneSelectingTemplates && selectedReleases.length > 0" class="w-100 contrast mat-card-inline-sm banner-info">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
      <strong class="highlight">x{{ selectedReleases.length }} releases</strong>
      <mat-icon *ngIf="!doneSelectingReleases" color="accent" matTooltip="Done selecting releases" (click)="doneSelectingReleases = true;">check</mat-icon>
      <mat-icon *ngIf="doneSelectingReleases" matTooltip="Select more releases" (click)="doneSelectingReleases = false;">clear</mat-icon>
    </div>
  </mat-card-content>
</mat-card>
<div *ngIf="selectedProductName !== undefined && doneSelectingTemplates && !doneSelectingReleases">
  <mat-card *ngIf="selectedReleases.length < 1" class="w-100 contrast mat-card-inline-sm banner-incomplete">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
        <strong>Now select releases</strong>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="contrast mat-card-inline-sm">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <mat-form-field>
        <input matInput type="text"
          [formControl]="searchReleasesField"
          (keyup)="doReleaseFilter($event.target.value)"
          (keyup.esc)="$event.target.value=''; doReleaseFilter('')"
          placeholder="Filter releases by name">
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <ng-container *ngFor="let item of filteredReleases">
    <mat-card class="contrast card-link mat-card-inline-sm" (click)="selectRelease(item.id)" [class.banner-info]="isReleaseSelected(item.id)">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="4px">
          <strong matTooltip="Release" [innerHtml]="item.name | encodeHtml | highlight: searchReleasesField.value"></strong>
          <small matTooltip="Release data">{{ item.releaseDate | date }}</small>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
<mat-card *ngIf="selectedProductName !== undefined && doneSelectingTemplates && doneSelectingReleases" class="contrast card-link mat-card-inline-sm banner-success" (click)="addReleaseItems()">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
      <strong *ngIf="!addingReleaseItems" matTooltip="Add release items">Add {{ this.data.homeConfigIds.length * selectedReleases.length * getSelectedItemCount() }} release items</strong>
      <strong *ngIf="addingReleaseItems">Adding release items...</strong>
    </div>
  </mat-card-content>
</mat-card>
